import React from 'react';
import { TwitterPicker } from 'react-color';
import _PaletteIcon from '@material-ui/icons/Palette';
import IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components/macro';
import Animation from '../Animation';
import Colors from '../../internal-components/Colors';
import Tooltip from '@material-ui/core/Tooltip';
import { BUTTON_VARIANT } from '../engine/ColorPickerEngine';
import MuiArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

const Container = styled.div``;

const PickerPositioner = styled.div`
  position: absolute;
  z-index: 999;
  margin: 0.5rem 0 0;
`;

const BackDrop = styled.div`
  z-index: 998;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;

const PaletteIcon = styled(_PaletteIcon)`
  && {
    transition: 0.5s;
    color: ${({ $color }) => ($color ? $color : Colors.ICON_GREY)};
  }
`;

const Box = styled.div`
  width: 100px;
  height: 37px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid ${Colors.BORDER_GREY};
  transition: 0.25s;
  padding: 0.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  &:hover {
    border: 1px solid ${Colors.DARK_GREY};
  }
`;

const InnerBox = styled.div`
  width: 100%;
  height: 100%;
  transition: 0.5s;
  background: ${({ $color }) => ($color ? $color : '#fff')};
  border-radius: 6px;
`;

const ArrowDropDownIcon = styled(MuiArrowDropDownIcon)`
  && {
    ${({ $isOpen }) => $isOpen && 'transform: scaleY(-1);'}
    transition: 0.25s;
  }
`;

const ColorPickerView = props => {
  return (
    <Container>
      {props.isPickerShowing ? (
        <BackDrop
          onClick={() => props.setIsPickerShowing(!props.isPickerShowing)}
        />
      ) : null}

      {props.buttonVariant === BUTTON_VARIANT.BOX && (
        <Box onClick={() => props.setIsPickerShowing(!props.isPickerShowing)}>
          <InnerBox $color={props.activeColor} />
          <ArrowDropDownIcon $isOpen={props.isPickerShowing} />
        </Box>
      )}
      {props.buttonVariant === BUTTON_VARIANT.PALLETE && (
        <Tooltip arrow title={props.tooltipText}>
          <IconButton
            size="small"
            onClick={() => props.setIsPickerShowing(!props.isPickerShowing)}
          >
            <PaletteIcon $color={props.activeColor} />
          </IconButton>
        </Tooltip>
      )}
      <PickerPositioner>
        <Animation
          in={props.isPickerShowing}
          type="grow"
          style={{ transformOrigin: '0 0 0' }}
          mountOnEnter
          unmountOnExit
        >
          <TwitterPicker
            triangle="hide"
            color={props.activeColor}
            onChangeComplete={props.onChangeComplete}
            colors={[
              '#FF6900',
              '#FCB900',
              '#7BDCB5',
              '#00D084',
              '#8ED1FC',
              Colors.PRIMARY,
              '#ABB8C3',
              Colors.OT_RED,
              '#F78DA7',
              '#9900EF'
            ]}
          />
        </Animation>
      </PickerPositioner>
    </Container>
  );
};

export default ColorPickerView;
